<template>
  <div>
    <div>
      <!-- <h1>{{$t('userInfo.name')}}</h1> -->
      <!--顶部导航-->
      <navgate></navgate>
      <!--内容区域-->
      <div class="web_box">
        <div class="web_content">
          <!--新闻内容-->
          <div class="news_box">
            <div class="news_head">{{detailData.title}}</div>
            <div class="news_date">{{detailData.createDate}}</div>
            <div class="new_content" v-html="detailData.content">
              
            </div>
          </div>
          <!--相关新闻-->
          <div class="content_box">
            <div class="news_title">
              <div class="news_h3">相关新闻</div>
            </div>
            <div class="list_box">
                <template v-if="detailData.relative && detailData.relative.length > 0">
                  <div v-for="(item,index) in detailData.relative" :key="index" class="news_list" @click="toDetailPage(item.messageId)">
                    <img :src="item.msgUrl">
                    <div class="list_titlt">{{item.title}}</div>
                    <div class="list_date">{{item.createDate}}</div>
                  </div>
                </template>
            </div>
            
           
          </div>

        </div>
        
      </div>
      <!--联系我们-->
      <footer-build></footer-build>
      
      
    </div>
    <!--<button @click="changLang">ccccc</button>-->
    <router-view/>
  </div>
  
</template>

<script>
import store from '../../store' 
import navgate from './navigate/navgate'
import HttpUtils from "../../util/HttpUtils";
export default {
  name: 'newsDetail',
  components:{navgate},
  props: ['detailId'],
  data(){
    return{
      detailData:{},
    }
  },
  methods:{
    xinxigongkai(){
      this.$router.push('partyBuild');
    },
    toDetailPage(messageId){
      let url = this.$router.resolve({
         name: 'newsDetail',
         query: {detailId:messageId}
       });
       this.$PageUtil.openNewPage(this,url.href)
    },
    changLang(){
      const lang = this.$i18n.locale //获取当前页面默认使用的语言
      console.log(lang)  //控制台输出 'zh'
      // 实现中英切换
      if(lang == 'zh'){ //如果默认是中文，在用户点击时就切换到英文状态
          this.$i18n.locale = 'en'
      }else {
          this.$i18n.locale = 'zh'
      }
    },
    getDetailData(){
      let that = this;
      new HttpUtils().sendGet(that, '/foundation_api/news/' + this.$route.query.detailId + '.json',  { }, function (sucess, res) {
        debugger
        that.detailData = res
        
      });
      
    },
  },
  mounted(){
    this.getDetailData()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less"> 
    @import '../../assets/css/ks_foundation.less';
    @import '../../assets/css/ks_media.less';
    @import '../../assets/fonts/iconfont.css';
</style>
